module.exports = __webpack_public_path__ + "media/svg/kw-75152e7e.svg";